import HTMLFlipBook from "react-pageflip";
import React, { useEffect, useRef } from 'react';
import { useCallback, useState } from "react";
// import page1 from "../texts/pages_content.js"
// import pages from "../texts/pages.js"
import { Col, Container, Row } from 'react-bootstrap';
import { ReactComponent as BMLogo } from '../svg_assets/bookmark30.svg';
import CircleButtonComponent from "./CircleButtonComponent.js";
import axios from "axios";


import { Button, Modal, ProgressBar } from 'react-bootstrap';
import { loginSuccess, logout } from '../slices/authSlice';
import { selectAuth } from '../slices/authSlice';
import { useSelector, useDispatch } from 'react-redux'
import formatDateToFrench from "../FormatDate.js";
import { FFmpeg } from '@ffmpeg/ffmpeg';
import { fetchFile, toBlobURL } from '@ffmpeg/util';
import ImageTileComponent from "./ImageTileComponent.js";


const PageCover = React.forwardRef((props, ref) => {
  return (
    <div className={props.className ? props.className : "page page-cover"} ref={ref} data-density="hard">

      <h2>{props.children}</h2>

    </div>
  );
});

const Page = React.forwardRef((props, ref) => {
  return (
    <div className="page" ref={ref}>
      <div className="page-content">
        <h2 className="page-header">{props.header}</h2>
        {/* <div className="page-image"></div> */}
        <div className="page-text">{props.children.split('\n').map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}</div>
        <div className="page-footer">{props.number}</div>
      </div>
    </div>
  );
});

const TwoPage = React.forwardRef((props, ref) => {

  const [showModal, setShowModal] = useState(false); // State for modal visibility
  const [selectedFiles, setSelectedFiles] = useState([]); // State for selected files
  const [uploadProgress, setUploadProgress] = useState(0); // State for upload progress
  const [uploadMessage, setUploadMessage] = useState(""); // State for upload message
  const [defiName, setDefiName] = useState(props.header + " - " + props.subtitle);
  const { isAuthenticated, userInformation } = useSelector(selectAuth);
  const [cancelTokenSource, setCancelTokenSource] = useState(null); // State to hold the cancel token
  const ffmpegRef = useRef([]);

  const resetModal = () => {
    setUploadMessage("")
    setUploadProgress(0)
  }


  const handleFileChange = (event) => {
    setSelectedFiles(event.target.files); // Update state with selected files
    console.log(event.target.files); // Update state with selected files
    setUploadMessage("")
    setUploadMessage("")
    setUploadProgress(0)
  };

  const showUploadModal = async (nb, main) => {
    try {
      if (isAuthenticated) {
        if (nb) {
          resetModal()
          setShowModal(true)
        } else {
          console.error("No defi nb defiend")
        }
      }
      else {
        alert("Please login to upload a defi")
      }
    } catch (error) {
      console.error(error);
    }
  }

  const compressVideo = async (file, onProgress) => {
    if (!file) return alert("Please select a video first.");

    const ffmpeg = new FFmpeg()
    ffmpegRef.current.push(ffmpeg)
    ffmpeg.on("progress", ({ progress, time }) => {
      // setUploadMessage(progress,time);
      var avg = ((progress * 100) + uploadProgress) / 2
      if (progress > uploadProgress) setUploadProgress(avg);
      console.log({ progress, time })
    });

    const baseURL = 'https://unpkg.com/@ffmpeg/core@0.12.6/dist/umd'

    if (!ffmpeg.loaded) {
      await ffmpeg.load({
        coreURL: await toBlobURL(`${baseURL}/ffmpeg-core.js`, 'text/javascript'),
        wasmURL: await toBlobURL(`${baseURL}/ffmpeg-core.wasm`, 'application/wasm'),
      });
    }

    //const fileArrayBuffer = await fetch(file).then((response) => response.arrayBuffer());
    //const fileBuffer = new Uint8Array(fileArrayBuffer);
    //ffmpeg.FS("writeFile", "input.mp4", fileBuffer);
    console.log("file")
    console.log(file)
    ffmpeg.writeFile('input.mp4', await fetchFile(file));

    //ffmpeg.writeFile('input.mp4', await fetchFile('https://raw.githubusercontent.com/ffmpegwasm/testdata/master/Big_Buck_Bunny_180_10s.webm'));

    // const totalFrames = await ffmpeg.getFrameCount("input.mp4");
    // let currentFrame = 0;

    // await ffmpeg.run("-i", "input.mp4", "-vcodec", "libx264", "-crf", "28", "output.mp4", {
    //   onFrame: () => {
    //     currentFrame++;
    //     const progress = Math.floor((currentFrame / totalFrames) * 100);
    //     onProgress(progress);
    //   },
    // });

    //await ffmpeg.exec(["-i", "input.mp4", "output.mp4"]);
    //await ffmpeg.exec(["-i", "input.mp4", "-vcodec", "libx264", "-crf", "28","-preset", "ultrafast", "output.mp4"]);
    await ffmpeg.exec(["-i", "input.mp4", "-vcodec", "libx264", "-preset", "veryfast", "-crf", "23", "output.mp4"]);

    // const data = ffmpeg.FS("readFile", "output.mp4");
    const fileData = await ffmpeg.readFile('output.mp4');
    const data = new Uint8Array(fileData);


    const blob = new Blob([data.buffer], { type: "video/mp4" });
    //blob.name = "tmp.mp4"
    console.log(blob)
    return blob;
  };

  const cancelUpload = async () => {
    resetModal()
    setShowModal(false)
    try {
      ffmpegRef.current.map(async (ffmpeg) => { await ffmpeg.terminate() })
    } catch (error) {
      console.log(error)
    }
    cancelTokenSource.cancel("Upload canceled by user.");

  }

  const upload = async () => {
    resetModal()
    const source = axios.CancelToken.source(); // Create a new cancel token
    setCancelTokenSource(source); // Store the cancel token in state

    try {
      const compressedFiles = await Promise.all(
        Array.from(selectedFiles).map(async (file) => {
          if (file.type.includes("video")) {

            //setUploadProgress(10); // Update upload progress
            setUploadMessage("Compressing Video")

            const compressedFile = await compressVideo(file);
            return compressedFile;
          } else {
            return file;
          }
        })
      );

      const formData = new FormData();
      for (let i = 0; i < compressedFiles.length; i++) {
        formData.append('files', compressedFiles[i]); // Append each file to FormData
      }

      formData.append('defiId', props.nb);


      await axios.post('/api/upload/challenge', formData, {
        cancelToken: source.token,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const total = progressEvent.total;
          const current = progressEvent.loaded;
          const percent = Math.floor((current / total) * 100);
          setUploadProgress(percent); // Update upload progress
          setUploadMessage(`Uploading`);
        },
      });
      setUploadMessage("Files uploaded successfully!"); // Success message
      // setUploadProgress(0); // Reset progress after successful upload
      // setShowModal(false); // Close modal
    } catch (error) {
      console.error("Error uploading files:", error);
      setUploadMessage("Error uploading files." + error); // Error message
      setUploadProgress(0); // Reset progress on error
    }
  }

 

  const text = props.children;
  const middle = Math.floor(text.length / 3);
  // Find the closest space before the middle index
  const leftIndex = text.lastIndexOf(" ", middle);
  const rightIndex = text.indexOf(" ", middle);
  // Choose the closest space index
  const splitIndex = leftIndex !== -1 ? leftIndex : rightIndex;
  const part1 = text.substring(0, splitIndex * 2 + 1).trim();
  const part2 = text.substring(splitIndex * 2 + 1).trim();
  return (
    <>
      <Modal show={showModal} onHide={cancelUpload}>
        <Modal.Header closeButton>
          <Modal.Title>{defiName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h2>Select Files to Upload</h2>
          <input
            type="file"
            accept="video/*,image/*,application/pdf"
            multiple
            onChange={handleFileChange}
          /> {/* File input */}
          {uploadProgress > 0 && (
            <ProgressBar className="my-3" now={uploadProgress} label={`${uploadProgress}%`} /> // Progress bar
          )}
          {uploadMessage && <p className="mt-3">{uploadMessage}</p>} {/* Display upload message */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelUpload}>
            Close
          </Button>
          <Button variant="primary" onClick={upload}>
            Upload
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="page" ref={ref}>
        <div className="page-content">
          <div className="page-header1">{props.header}</div>
          <h2 className="page-header2">{props.subtitle}</h2>
          {/* <div className="page-image"></div> */}
          <div className="page-text font-size: clamp(1px, 5vw, 50px)">{part1.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
          </div>
          <div className="page-footer">{props.number}</div>
        </div>
      </div>


      <div className="page" ref={ref}>
        <div className="page-content">
          <h2 className="page-header1">{formatDateToFrench(props.date)}</h2>
          {/* <div className="page-image"></div> */}
          <div className="page-text font-size: clamp(1px, 5vw, 24px)">{part2.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
              <br />
            </React.Fragment>
          ))}


            {props.disabled ?
              (<>
                <button className="oldButton" disabled><a>Open Defi Details</a></button>
                <button className="oldButton" disabled>Upload</button>
              </>)
              :
              (<>
                <button className="oldButton" href={props.link ? props.link : "#"} ><a href={props.link ? props.link : "#"} download>Open Defi Details</a></button>
                <button className="oldButton" onClick={() => showUploadModal(props.nb, props.main)}>Upload</button>
              </>)
            }


          </div>
          <div className="page-footer">{props.number + 1}</div>
        </div>
      </div>
    </>
  );
});






function Book(props) {
  const [files, setFiles] = useState([]);
  const [activePage, setActivePage] = useState();

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const response = await axios.get(`/api/defisuploads/patrouille/${activePage/2+0.5}`);
        var currentFiles = files;
        files.slice()
        files.push(response.data.files);
        
        console.log("aa")
      } catch (error) {
        console.error("Error fetching files:", error);
      }
    };
    fetchFiles();
  }, [activePage]);

 

  var pageFlip = useRef("aa")
  // const [pageFlip,setPageFlip] = useState({})
  const { isAuthenticated, userInformation } = useSelector(selectAuth);

  return (
    <Container>
      <Row>
        <Col sm={12} md={6}>
          <HTMLFlipBook
            width={11}
            height={17}
            size="stretch"
            maxShadowOpacity={0.5}
            showCover={true}
            drawShadow={true}
            mobileScrollSupport={true}
            className="demo-book"
            ref={pageFlip}
            onFlip={(e) => console.log(setActivePage(e.data))}

          >
            <PageCover className={"page page-cover"}></PageCover>

            {props.pages.map((page, index) => (
              <TwoPage
                key={page.id} // Use a unique key, ideally an ID from the page object if available
                header={page.title}
                subtitle={page.subtitle}
                date={page.target_date}
                number={index + 1} // Number starts from 1
                nb={page.id} // Number starts from 1
                link={"documents/" + page.attachment}
                disabled={!page.enabled}
                main={page.main}
              >
                {page.content}
              </TwoPage>
            ))

            }


            {/* <TwoPage number={2} header="H1" subtitle={""} text2={" "}></TwoPage> */}
            <PageCover className={"page backpage-cover"}> </PageCover>
          </HTMLFlipBook>
        </Col>

        <Col sm={12} md={6}>
          <div className="button-container">
            {props.pages.map((page, index) => (
              <CircleButtonComponent
                onClick={() => { pageFlip.current.pageFlip().turnToPage(2 * index + 1) }}
                size={page.main ? 50 : 30}
                disabled={!page.enabled}
              />
            ))}
          </div>
          {/* <Button onClick={() =>(pageFlip.current.pageFlip().turnToPage(7))}>Go to page 7</Button> */}

        </Col>


      </Row>
      <Row className="my-2">
      {/* {files.length > 0 && <ImageTileComponent data={files} />} */}
      </Row>
    </Container>
  );
}

export default Book;